import React, { Component } from 'react';
import { connect } from 'react-redux';
import CameraCapture from '../shared/cameraCapture';
import imageHelper from '../../helpers/image';
import { alerts } from '../../actions/alerts';
import { updateMember } from '../../actions/members';

class CheckinMember extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showCamera: false,
			isUploading: false
		};
	}

	toggleCamera() {
		this.setState({ showCamera: !this.state.showCamera });
	}

	onError(message) {
		this.props.dispatch(alerts.error(message));
	}

	onSave(file) {
		if (file.size > imageHelper.MAX_IMAGE_SIZE) {
			this.props.dispatch(alerts.error('Image file is too large. Please take a photo under 6 MB.'));
			return;
		}

		this.setState({ isUploading: true });

		imageHelper.resizeImage(file, imageHelper.PROFILE_IMAGE_SIZE)
			.then((resizedFile) => {
				const formData = new FormData();
				formData.append('image', resizedFile);
				this.props.updateMember(formData, (success) => {
					this.setState({ isUploading: false, showCamera: false });
					if (success) {
						this.props.dispatch(alerts.success('Profile photo updated successfully.'));
					}
				});
			})
			.catch(() => {
				this.setState({ isUploading: false });
				this.props.dispatch(alerts.error('Could not process photo. Please try again.'));
			});
	}

	render() {
		return [
			<li key="update-photo-link" className="footer-link" data-toggle="collapse" data-target="#main-nav.in">
				<a onClick={this.toggleCamera.bind(this)}>Update Photo</a>
			</li>,
			<CameraCapture
				key="camera-capture"
				visible={this.state.showCamera}
				isUploading={this.state.isUploading}
				onSave={this.onSave.bind(this)}
				onError={this.onError.bind(this)}
				onClose={this.toggleCamera.bind(this)}
			/>
		];
	}
}

function mapDispatchToProps(dispatch) {
	return {
		dispatch,
		updateMember: (formData, done) => dispatch(updateMember(formData, done))
	};
}

export default connect(null, mapDispatchToProps)(CheckinMember);
